<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'"
          >{{ aLang.c_create }} thuyết minh tự động</span
        >
        <span v-if="mData.viewMode == 'update'"
          >{{ aLang.c_update }} thuyết minh tự động và thêm mới</span
        >
        <span v-if="mData.viewMode == 'detail'"
          >{{ aLang.c_detail }} thuyết minh tự động</span
        >
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body card-body__css">
        <el-form
          ref="myDataForm"
          :model="mData.dataForm"
          :rules="mData.validForm"
          label-position="top"
        >
          <el-row :gutter="10">
            <el-col :sm="6" :md="6" :lg="4">
              <el-form-item>
                <div slot="label">
                  <span class="custom__label">Ảnh điểm/hiện vật</span>
                </div>
                <el-upload
                  action
                  :auto-upload="false"
                  list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhHienVat.limit"
                  :accept="mData.fileUploadOption.AnhHienVat.accept"
                  :on-change="fn_uploadChangeAnhHienVat"
                  :on-preview="fn_uploadPreviewAnhHienVat"
                  :on-remove="fn_uploadRemoveAnhHienVat"
                  :on-exceed="fn_uploadExceedAnhHienVat"
                  :file-list="mData.fileUploadOption.AnhHienVat.fileList"
                  :disabled="mData.viewMode == 'detail'"
                  :class="[
                    mData.fileUploadOption.AnhHienVat.fileList.length > 0
                      ? 'hidden-icon-upload'
                      : '',
                  ]"
                >
                  <i class="el-icon-plus"></i>
                  <div
                    slot="tip"
                    class="el-upload__tip"
                    v-if="mData.viewMode != 'detail'"
                  >
                    <p class="mb-0" style="line-height: 18px; font-weight: 500">
                      Hỗ trợ định dạng jpg, jpeg, png
                    </p>
                    <p class="mb-0" style="line-height: 18px; font-weight: 500">
                      Dung lượng tải lên tối đa 2MB
                    </p>
                    <!-- <p class="mb-0" style="line-height: 18px;">Kích thước ảnh gốc
                    khuyến khích sử dụng theo kích thước tối thiểu là 500x262px và tối đa là 1200x628px!</p> -->
                  </div>
                </el-upload>
                <p class="error" v-if="showError">Vui lòng tải ảnh</p>
              </el-form-item>
              <el-popover
                v-if="mData.viewMode != 'detail'"
                style="color: #fff"
                placement="bottom-start"
                width="340"
                trigger="click"
              >
                <el-link
                  href="javascript:"
                  class="warning-text"
                  slot="reference"
                  :underline="false"
                  ><i class="el-icon-info" style="margin-right: 5px"></i>Lưu ý
                  khi tải ảnh</el-link
                >
                <div class="alert-message">
                  <p class="mb-0">
                    Hình ảnh sau khi đăng tải sẽ được thay đổi kích thước để
                    hiển thị phù hợp trên giao diện ứng dụng Du lịch Việt Nam.
                    Để chất lượng hình ảnh tối ưu nhất, kích thước ảnh gốc
                    khuyến khích sử dụng theo kích thước tối thiểu là 500x262px
                    và tối đa là 1200x628px!
                  </p>
                  <p></p>
                </div>
              </el-popover>
            </el-col>
            <el-col :sm="24" :lg="20" class="d-flex-album1">
              <label class="label-image" style="margin-right: 10px"
                >ALBUM ẢNH</label
              >
              <el-row>
                <el-col
                  v-for="(item, index) in mData.listImageUrl"
                  :key="index"
                  :span="3"
                  :class="{
                    'list-album-image text-center mt-2': true,
                    'hide-element-blank': !item.anh_id,
                  }"
                >
                  <div class="position-css">
                    <el-image
                      fit="cover"
                      class="el-image-css"
                      :src="item.url"
                      :preview-src-list="mData.dataDefault.listAlbumImage"
                      :lazy="true"
                    >
                      <div slot="error" class="el-image__error">
                        <span class="small" style="line-height: 1rem">{{
                          item.name ? item.name : ""
                        }}</span>
                      </div>
                    </el-image>
                    <el-tooltip
                      v-if="mData.viewMode != 'detail'"
                      class="item"
                      effect="dark"
                      content="Click để xoá"
                      placement="top-end"
                    >
                      <div
                        class="remove-icon c-ponit"
                        @click="uploadRemoveFile(item.anh_id)"
                      >
                        <el-image
                          style="width: 100%"
                          src="img/remove_icon.png"
                          fit="cover"
                        >
                        </el-image>
                      </div>
                    </el-tooltip>
                  </div>
                </el-col>
                <el-col
                  :md="4"
                  :xl="3"
                  v-if="
                    mData.viewMode != 'detail' && mData.listImageUrl.length < 6
                  "
                  class="upload-album-image"
                >
                  <el-form-item class="mb-3">
                    <el-upload
                      action
                      multiple
                      :auto-upload="false"
                      :show-file-list="false"
                      list-type="picture-card"
                      :limit="null"
                      :accept="mData.fileUploadOption.AlbumAnh.accept"
                      :on-change="uploadChangeAlbumAnh"
                      v-if="!mData.disableUpload"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-popover
                v-if="mData.viewMode != 'detail'"
                style="color: #fff"
                placement="bottom-start"
                width="300"
                trigger="click"
              >
                <el-link
                  href="javascript:"
                  class="warning-text"
                  slot="reference"
                  ><i class="el-icon-info" style="margin-right: 5px"></i>Lưu ý
                  khi tải ảnh</el-link
                >
                <div class="alert-message">
                  <p>
                    Hình ảnh sau khi đăng tải sẽ được thay đổi kích thước để
                    hiển thị phù hợp trên giao diện ứng dụng Du lịch Việt Nam.
                    Để chất lượng hình ảnh tối ưu nhất, kích thước ảnh gốc
                    khuyến khích sử dụng theo kích thước tối thiểu là 500x262px
                    và tối đa là 1200x628px! Tối đa chỉ tải lên 6 ảnh.
                  </p>
                </div>
              </el-popover>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item label="Link giới thiệu" prop="destinationUrl">
                <el-input
                  v-model="mData.dataForm.destinationUrl"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :sm="7"
              v-show="
                (mData.viewMode === 'create' || showSelectLanguage) &&
                mData.viewMode !== 'detail'
              "
            >
              <el-form-item
                label="Chọn ngôn ngữ"
                prop="languageCode"
                class="d-flex-language"
              >
                <el-select
                  v-model="mData.dataForm.languageCode"
                  :placeholder="aLang.c_select"
                  :disabled="
                    mData.viewMode === 'detail' || disableAddLanguageTabs
                  "
                  @input="forceUpdateUI"
                  @change="showButtonAddLanguageTabs"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listNgonNgu"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :sm="4"
              v-show="showAddLanguageTabs && mData.viewMode !== 'detail'"
            >
              <el-button
                @click="addLanguageTabs(mData.dataForm.languageCode)"
                :disabled="disableAddLanguageTabs"
              >
                <i class="el-icon-plus" />
                Thêm ngôn ngữ</el-button
              >
            </el-col>
          </el-row>
          <el-tabs
            v-model="mData.editableLanguageTabs"
            type="border-card"
            v-show="mData.languageTabs.length > 0"
            @tab-click="tabClick"
            @tab-remove="removeLanguageTab"
          >
            <el-tab-pane
              v-for="(item, index) in mData.languageTabs"
              :key="item.key"
              :label="item.title"
              :name="item.name"
              :closable="item.showButtonClose"
            >
              <el-form-item
                class="requied-label"
                label="Tên điểm/hiện vật"
                prop=""
              >
                <el-input
                  v-model="item.translation.guideName"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  maxlength="50"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item
                class="requied-label"
                label="Nội dung giới thiệu"
                prop=""
              >
                <el-input
                  type="textarea"
                  v-model="item.translation.description"
                  :disabled="mData.viewMode == 'detail'"
                  :autosize="{ minRows: 3, maxRows: 10 }"
                  maxlength="2000"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item class="requied-label" label="File thuyết minh">
                <div v-if="!item.showFileAudio">
                  <el-upload
                    class="upload"
                    :auto-upload="false"
                    action
                    :limit="mData.fileUploadOption.Audio.limit"
                    :accept="mData.fileUploadOption.Audio.accept"
                    :on-change="(file, fileList) => fn_uploadFileAudio(file, fileList, item)"
                    :file-list="item.fileList"
                  >
                    <el-button size="small" type="primary">Tải file</el-button>
                    <div slot="tip" class="el-upload__tip">
                      <p class="mb-0">Hỗ trợ định dạng mp3, mp4, mov</p>
                      <p class="mb-0">Dung lượng tải lên tối đa 10MB</p>
                    </div>
                  </el-upload>

                  <div class="list-file__custom">
                    <div
                      v-for="(itemAudio, indexAudio) in mData.audiosNew"
                      :key="indexAudio"
                      class="list-file__custom-item"
                      v-show="
                        itemAudio.languageCode ===
                          item.name &&
                        itemAudio.audioData &&
                        itemAudio.audioData.length > 0
                      "
                    >
                      <p
                        class="list-file__custom-item-name"
                        :title="itemAudio.name"
                        @click="fn_PreviewFileAudio(itemAudio)"
                      >
                        {{ itemAudio.fileName }}
                      </p>
                      <i
                        v-if="itemAudio.type === 'upload'"
                        class="fas fa-trash-alt list-file__custom-item-icon"
                        @click="fn_deleteFileAudio(itemAudio)"
                        title="Xóa file"
                      ></i>
                    </div>
                  </div>
                </div>
                <div v-if="item.showFileAudio" class="d-flex align-items-center">
                  <mini-audio
                    :audio-source="item.audio ? item.audio.signedAudioUrl : ''"
                  />
                  <i
                    v-if="mData.viewMode !== 'detail'"
                    class="fas fa-trash-alt list-file__custom-item-icon ml-3"
                    @click="fn_removeExistingAudio(item)"
                    title="Thay thế file thuyết minh"
                  ></i>
                </div>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>

          <el-row :gutter="10">
            <div class="button__group text-center mt-3">
              <el-button
                type="info"
                @click="fn_submit('create')"
                plain
                v-if="mData.viewMode == 'create'"
              >
                {{ aLang.c_create }}
              </el-button>
              <el-button
                type="info"
                @click="fn_submit('update')"
                plain
                v-if="mData.viewMode == 'update'"
              >
                {{ aLang.c_update }}
              </el-button>
              <el-button type="info" @click="fn_go()" plain>
                {{ aLang.c_back }}
              </el-button>
            </div>
          </el-row>
        </el-form>
      </div>
    </div>
    <el-image-viewer
      class="dialog__image-viewer"
      v-if="visibleDialogImage"
      :on-close="closeViewer"
      :url-list="[urlImage]"
    />
    <Loading v-if="loading" />
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataService from "../../../service/DataService";
import ExtensionService from "../../../service/ExtensionService";
import AutomaticCommentaryModel from "./AutomaticCommentaryModel";
import DDATApi from "../../../moduleApi/DDATApi";
import mushroomDulich from "../../../service/api/dulich-api";
import Loading from "@/component/Loading";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import Swal from "sweetalert2";

export default {
  components: {
    Loading,
    ElImageViewer,
  },
  data() {
    return {
      model: "",
      aLang: LanguageService.lang,
      loading: false,
      visibleDialogImage: false,
      urlImage: "",
      showError: false,
      showErrorAudio: false,
      showAddLanguageTabs: false,
      showSelectLanguage: true,
      disableAddLanguageTabs: false,
      mData: {
        arrayUpdateAudio: [],
        editableLanguageTabs: "1",
        indexLanguageTabs: 1,
        tabsName: "",
        languageTabs: [],
        audiosNew: [], // bổ sung theo api mới audio là mảng obj
        translationsNew: [], // bổ sung theo api mới là mảng obj
        moduleName: "AutomaticCommentary",
        viewMode: "create",
        dataForm: MethodService.copyObject(AutomaticCommentaryModel.dataForm),

        validForm: AutomaticCommentaryModel.validForm,
        currentUser: MethodService.copyObject(MethodService.getCurrentUser()),
        safePlaceData: undefined,
        dataAudioUrl: {
          signedAudioUrl: undefined,
          imageUrl: undefined,
        },
        dataDefault: {
          listNgonNgu: DataService.Languages,
          listAlbumImage: [],
        },
        dataCurrent: {
          listNgonNgu: DataService.Languages,
        },
        fileUploadOption: {
          AnhHienVat: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            fileList: [],
            dialogVisible: false,
          },
          Audio: {
            limit: null,
            accept: ".mp3, .mp4, .mov",
            fileList: [],
            dialogVisible: false,
          },
          AlbumAnh: {
            limit: 6,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
        listImageUrl: [],
      },
      showFile: false,
      imageType: ["jpg", "png", "jpeg"],
      isUploadNewAudio: false,
    };
  },
  methods: {
    forceUpdateUI() {
      this.$forceUpdate();
    },
    closeViewer() {
      this.visibleDialogImage = false;
    },

    beforeCloseDialogImage() {
      this.urlImage = "";
      this.visibleDialogImage = false;
    },
    async getDataDDAT() {
      const apiRes = await DDATApi.list({
        filters: `nguoi_tao_id=${this.mData.currentUser.id}`,
        limit: 1,
      });
      this.mData.safePlaceData = apiRes.result[0];
    },
    getDataByGuideCode(guideCode) {
      this.loading = true;
      let header = {
        "X-HTTP-Method-Override": "agm_get_guide",
      };
      let body = {
        start: 0,
        limit: 1,
        placeCode: this.mData.safePlaceData.agmPlace.placeCode,
        guideCode: guideCode,
      };
      Promise.all([
        mushroomDulich.thedulich.agm_get_guideAsync({
          body: body
        }),
      ])
        .then((res) => {
          this.getAudioUrl(res[0].result.data[0].id);
          this.mData.dataForm = res[0].result.data[0];
          this.isUploadNewAudio = false;

          if (res[0].result.data[0].imageUrl) {
            this.mData.fileUploadOption.AnhHienVat.fileList = [];
            this.mData.dataForm.imgData = res[0].result.data[0].imageUrl;
            const pathname = new URL(res[0].result.data[0].imageUrl).pathname;
            this.mData.dataForm.imgExtension = pathname.substring(
              pathname.lastIndexOf(".") + 1
            );
            let data = {
              id: res[0].result.data[0].imageUrl,
              name: res[0].result.data[0].imageUrl,
              url: res[0].result.data[0].imageUrl,
            };
            this.mData.fileUploadOption.AnhHienVat.fileList.push(data);
          }
        })
        .catch((err) => {
          console.error("err", err);
          this.loading = false;
        });
    },
    getAudioUrl(guideId) {
      let header = {
        "X-HTTP-Method-Override": "agm_guide_get_audio_url",
      };
      let body = {
        guideId: guideId,
      };
      Promise.all([
        mushroomDulich.thedulich.agm_guide_get_audio_urlAsync({
          body: body
        }),
      ])
        .then((res) => {
          this.mData.dataAudioUrl = res[0].result.data;
          let translations1 = res[0].result.data.translations;
          if (translations1 && translations1.length < DataService.Languages.length) {
            this.showAddLanguageTabs = true;
            this.showSelectLanguage = true;
          } else {
            this.showAddLanguageTabs = false;
            this.showSelectLanguage = false;
          }

          translations1.forEach((item) => {
            this.mData.dataDefault.listNgonNgu =
              this.mData.dataDefault.listNgonNgu.filter(
                (itemNgonNgu) => itemNgonNgu.id !== item.languageCode
              );

            this.mData.audiosNew.push({
              languageCode: item.languageCode,
              audioData: "1",
              audioExtension: "mp3",
              fileName: "",
              type: "",
              signedAudioUrl: item.signedAudioUrl,
              id: item.id,
            });
            this.mData.translationsNew.push({
              languageCode: item.languageCode,
              description: item.description,
              guideName: item.guideName,
              id: item.id,
            });
          });
          if (this.mData.dataDefault.listNgonNgu.length > 0) {
            this.mData.dataForm.languageCode =
              this.mData.dataDefault.listNgonNgu[0].id;
          } else this.mData.dataForm.languageCode = "vi";

          translations1.forEach((item, index) => {
            const audioObj = this.mData.audiosNew.find(a => a.languageCode === item.languageCode);
            const transObj = this.mData.translationsNew.find(t => t.languageCode === item.languageCode);

            this.mData.languageTabs.push({
              key: index++,
              title: this.renderNameTabs(item.languageCode),
              name: item.languageCode,
              id: item.languageCode,
              idForDelete: item.id,
              showButtonClose:
                item.id &&
                item.languageCode !== "vi" &&
                this.mData.viewMode !== "detail"
                  ? true
                  : false,
              audio: audioObj,
              translation: transObj,
              audios: this.mData.audiosNew,
              translations: this.mData.translationsNew,
              showFileAudio: true,
              indexTabs: DataService.Languages.findIndex(l => l.id === item.languageCode) !== -1 
                ? DataService.Languages.findIndex(l => l.id === item.languageCode) + 1 
                : 99,
              fileList: [],
            });
          });
          this.mData.languageTabs.sort((a, b) => a.indexTabs - b.indexTabs);
          this.mData.editableLanguageTabs = "vi";

          if (!res[0].result.data.albums) res[0].result.data.albums = [];
          this.mData.listImageUrl = res[0].result.data.albums.map((item) => {
            return {
              name: item.imageId,
              anh_id: item.imageId,
              url: ExtensionService.urlImg + item.imageId,
              // ExtensionService.urlImg +
              // item.imageId +
              // "&r=clip&w=400&h=600&ha=center",
            };
          });

          setTimeout(() => {
            this.showFile = true;
            this.loading = false;
          }, 500);
        })
        .catch((err) => {
          let data = err.detail;
          if (
            data &&
            data.param &&
            data.param.messages &&
            data.param.messages.length > 0
          ) {
            window.toastr.error(data.param.messages.join(" "));
          } else {
            window.toastr.error("Có lỗi xảy ra vui lòng thử lại!");
          }
          this.loading = false;
        });
    },
    fn_submit(mode) {
      this.loading = true;
      this.$refs.myDataForm.validate((valid) => {
        if (valid) {
          let hasViAudio = false;
          for (const item of this.mData.audiosNew) {
            if (item.languageCode === "vi" && item.audioData) {
              hasViAudio = true;
            }
          }
          if (!hasViAudio) {
            window.toastr.warning("Yêu cầu phải có thuyết minh Tiếng Việt");
            this.loading = false;
            return;
          }

          for (const item of this.mData.translationsNew) {
            if (
              !item.guideName ||
              !item.description ||
              item.guideName.trim() === "" ||
              item.description.trim() === ""
            ) {
              window.toastr.warning(
                "Tên điểm/hiện vật hoặc Nội dung giới thiệu không được để trống"
              );
              this.loading = false;
              return;
            }
          }

          if (!this.mData.dataForm.imgData) {
            this.showError = true;
            this.loading = false;
            return;
          }

          for (const item of this.mData.audiosNew) {
            if (!item.audioData) {
              window.toastr.warning("Yêu cầu tải file thuyết minh");
              this.loading = false;
              return;
            }
          }

          let dataAudioGuide = {
            header: {},
            body: {
              clientPlaceCode: this.mData.currentUser.account,
              guideName: this.mData.translationsNew.filter(
                (item) => item.languageCode === "vi"
              )[0].guideName,
              destinationUrl: this.mData.dataForm.destinationUrl,
              description: this.mData.translationsNew.filter(
                (item) => item.languageCode === "vi"
              )[0].description,
              imgData: this.mData.dataForm.imgData,
              audios:
                this.mData.viewMode === "create"
                  ? this.mData.audiosNew
                  : this.mData.arrayUpdateAudio,
              translations: this.mData.translationsNew || [],
            },
          };

          if (mode == "create") {
            dataAudioGuide.header = {
              "X-HTTP-Method-Override": "agm_guide_integration_register",
            };
            this.createAudioGuide(dataAudioGuide);
          } else if (mode == "update") {
            dataAudioGuide.header = {
              "X-HTTP-Method-Override": "agm_guide_integration_update",
            };
            dataAudioGuide.body.guideCode = this.mData.dataForm.guideCode;
            dataAudioGuide.body.imgExtension = this.mData.dataForm.imgExtension;
            this.updateAudioGuide(dataAudioGuide);
          }
        } else {
          this.loading = false;
          return false;
        }
      });
    },
    // Thêm mới thuyết minh tự động
    async createAudioGuide(dataAudioGuide) {
      try {
        const res = await mushroomDulich.thedulich.agm_guide_integration_registerAsync({
          body: dataAudioGuide.body
        });
        await mushroomDulich.thedulich.agm_guide_create_image_albumAsync({
          body: {
            guide_code: res.result.data.guideCode,
            guide_id: res.result.data.guideId,
            albums: this.mData.listImageUrl.map((item) => item.anh_id),
          }
        });
        window.toastr.success("Thêm mới thuyết minh thành công");
        this.loading = false;
        this.fn_go();
      } catch (err) {
        let message = "Thêm mới thuyết minh không thành công";
        // if (err && err.detail) {
        //   try {
        //     let data = JSON.parse(err.detail);
        //     if (
        //       data &&
        //       data.param &&
        //       data.param.messages &&
        //       data.param.messages.length > 0
        //     ) {
        //       message = data.param.messages.join(" ");
        //     }
        //   } catch (e) {
        //     message = err.detail;
        //   }
        // } else if (err && err.message) {
        //   message = err.message;
        // }
        window.toastr.error(message);
        this.loading = false;
      }
    },
    // Cập nhật thuyết minh tự động
    async updateAudioGuide(dataAudioGuide) {
      try {
        await mushroomDulich.thedulich.agm_guide_integration_updateAsync({
          body: dataAudioGuide.body
        });
        await mushroomDulich.thedulich.agm_guide_create_image_albumAsync({
          body: {
            guide_code: this.mData.dataForm.guideCode,
            guide_id: this.mData.dataAudioUrl.guideId,
            albums: this.mData.listImageUrl.map((item) => item.anh_id),
          }
        });
        window.toastr.success("Cập nhật thuyết minh thành công");
        this.loading = false;
        this.fn_go();
      } catch (err) {
        let message = "Cập nhật thuyết minh không thành công";
        // if (err && err.detail) {
        //   try {
        //     let data = JSON.parse(err.detail);
        //     if (
        //       data &&
        //       data.param &&
        //       data.param.messages &&
        //       data.param.messages.length > 0
        //     ) {
        //       message = data.param.messages.join(" ");
        //     }
        //   } catch (e) {
        //     message = err.detail;
        //   }
        // } else if (err && err.message) {
        //   message = err.message;
        // }
        window.toastr.error(message);
        this.loading = false;
      }
    },
    //Upload ảnh
    beforeUploadImage(file) {
      const isOver2MB = file.size / 1024 / 1024 > 2;
      const typeFile = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      const typeImageValid = ["jpg", "png", "jpeg"];
      if (isOver2MB && !typeImageValid.includes(typeFile)) {
        toastr.warning(
          "Ảnh điểm/hiện vật có dung lượng tối đa 2MB và có định dạng png, jpg, jpeg!"
        );
      } else if (isOver2MB) {
        toastr.warning("Ảnh điểm/hiện vật có dung lượng tối đa 2MB!");
      } else if (!typeImageValid.includes(typeFile)) {
        toastr.warning("Ảnh điểm/hiện vật có định dạng png, jpg, jpeg!");
      }
      return isOver2MB || !typeImageValid.includes(typeFile);
    },

    fn_uploadRemoveAnhHienVat(file, fileList) {
      this.mData.dataForm.imgData = null;
      this.mData.fileUploadOption.AnhHienVat.fileList = [];
      this.showError = true;
    },
    async fn_uploadChangeAnhHienVat(file, fileList) {
      try {
        if (this.beforeUploadImage(file)) {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
          return;
        }
        const res = await ExtensionService.upload(file, "ThuyetMinhTuDong");
        if (!res.result) return;
        this.mData.dataForm.imgData = res.result;
        this.mData.fileUploadOption.AnhHienVat.fileList = fileList;
        this.showError = false;
      } catch (error) {
        fileList.forEach((el, i) => {
          if (el.uid == file.uid) {
            fileList.splice(i, 1);
          }
        });
      }
    },
    fn_uploadExceedAnhHienVat(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhHienVat.limit} file`
      );
    },
    fn_uploadPreviewAnhHienVat(file) {
      this.urlImage = file.url;
      setTimeout(() => {
        this.visibleDialogImage = true;
      }, 100);
    },
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 <= 10;
      if (!isLt10M) {
        toastr.warning("File thuyết minh có dung lượng tối đa 10MB!");
      }
      return isLt10M;
    },
    async fn_uploadFileAudio(file, fileList, itemTab) {
      try {
        if (!this.beforeUpload(file)) {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
          if (itemTab) itemTab.fileList = fileList;
          return;
        }
        const res = await ExtensionService.upload(file, "ThuyetMinhTuDong");
        if (!res.result) return;
        this.showFile = false;
        const fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
        
        const langCode = itemTab ? itemTab.name : this.mData.editableLanguageTabs;
        if (this.mData.viewMode === "update") {
          this.mData.arrayUpdateAudio = this.mData.arrayUpdateAudio.filter(
            (item) => item.languageCode !== langCode
          );
          this.mData.arrayUpdateAudio.push({
            audioData: res.result,
            audioExtension: fileExtension,
            fileName: file.name,
            type: "upload",
            languageCode: langCode,
          });
        }
        this.mData.audiosNew.forEach((item) => {
          if (item.languageCode === langCode) {
            item.audioData = res.result;
            item.audioExtension = fileExtension;
            item.fileName = file.name;
            item.type = "upload";
          }
        });

        if (itemTab) {
          itemTab.fileList = fileList;
        }
        this.mData.fileUploadOption.Audio.fileList = fileList;
        this.isUploadNewAudio = true;
        this.showErrorAudio = false;
      } catch (error) {
        fileList.forEach((el, i) => {
          if (el.uid == file.uid) {
            fileList.splice(i, 1);
          }
        });
        if (itemTab) itemTab.fileList = fileList;
      }
    },
    fn_PreviewFileAudio(file) {
      window.open(ExtensionService.urlImg + file.audioData);
      // let audio = new Audio(file.audioData)
      // audio.play()
    },
    fn_deleteFileAudio(file) {
      file.audioData = "";
      file.audioExtension = "";
      file.fileName = "";
      file.type = "";
      
      const tab = this.mData.languageTabs.find(t => t.name === file.languageCode);
      if (tab) {
        tab.fileList = [];
      }
      
      this.mData.fileUploadOption.Audio.fileList = [];
      if (this.mData.viewMode === "update") {
        this.mData.arrayUpdateAudio = this.mData.arrayUpdateAudio.filter(
          (item) => item.languageCode !== file.languageCode
        );
      }
      if (this.mData.dataAudioUrl) this.showFile = true;
      this.showErrorAudio = true;
    },
    fn_removeExistingAudio(item) {
      item.showFileAudio = false;
      if (item.audio) {
        item.audio.audioData = "";
        item.audio.audioExtension = "";
        item.audio.fileName = "";
        item.audio.type = "";
      }
      item.fileList = [];
      this.mData.fileUploadOption.Audio.fileList = [];
    },
    fn_go() {
      this.$router.go(-1);
    },
    validateFieldMethod(prop) {
      this.$refs["myDataForm"].validateField(prop);
    },
    fn_checkTypeFile(fileType) {
      return this.imageType.includes(fileType);
    },
    fn_uploadCheckFileImageSize(file) {
      return MethodService.checkFileSize(file, 10);
    },
    checkIsEnoughFile(arr, fileList) {
      if (fileList.length > 6) {
        window.toastr.info("Chỉ tải lên tối đa 6 ảnh");
        return true;
      } else {
        return false;
      }
    },
    uploadChangeAlbumAnh(file, fileList) {
      let fileType = file.name
        .substr(file.name.length - 4, 4)
        .replace(".", "")
        .toLowerCase();
      if (!this.fn_checkTypeFile(fileType)) {
        window.toastr.warning(
          "Định dạng file hỗ trợ jpg, png, jpeg! Vui lòng tải các file đúng định dạng!"
        );
        return;
      }
      if (!this.fn_uploadCheckFileImageSize(file)) {
        window.toastr.warning(
          "Chỉ tải lên ảnh không quá 10MB! Vui lòng tải lại"
        );
        return;
      }
      let item = {};
      let listImage = [];
      let arrImage = this.mData.listImageUrl;
      if (fileList.length > 6) {
        window.toastr.info("Số lượng ảnh trong album ảnh tối đa là 6 ảnh.");
        return;
      }
      ExtensionService.upload(file, "anhAlbumAudioGuide")
        .then((res) => {
          arrImage.push({
            anh_id: res.result,
          });
          for (const element of arrImage) {
            item = {
              name: element.anh_id,
              anh_id: element.anh_id,
              url: ExtensionService.urlImg + element.anh_id,
            };
            listImage.push(item);
          }
          this.mData.listImageUrl = listImage.splice(0, 6);
        })
        .catch((e) => {
          console.log("lỗi tải ảnh", e);
        });
    },
    uploadRemoveFile(fileId) {
      this.mData.listImageUrl = this.mData.listImageUrl.filter(
        (e) => e.anh_id != fileId
      );
    },
    // -------------
    showButtonAddLanguageTabs() {
      this.showAddLanguageTabs = true;
    },
    tabClick(tabInfo) {
      this.mData.editableLanguageTabs = tabInfo.name;
    },
    addLanguageTabs(data) {
      let count = 0;
      this.mData.translationsNew.forEach((item) => {
        if (
          !item.guideName ||
          !item.description ||
          item.guideName.trim() === "" ||
          item.description.trim() === ""
        ) {
          window.toastr.warning(
            "Tên điểm/hiện vật hoặc Nội dung giới thiệu không được để trống"
          );
          count++;
        }
      });

      this.mData.audiosNew.forEach((item) => {
        if (!item.audioData) {
          window.toastr.warning("Yêu cầu tải file thuyết minh");
          count++;
        }
      });
      if (count === 0) {
        let arrNameTile = this.mData.dataDefault.listNgonNgu.filter(
          (item) => item.id === data
        );
        let titleTabsLanguage = "";
        if (arrNameTile.length > 0) {
          titleTabsLanguage = arrNameTile[0].name;
          let newArrayNgonNgu = this.mData.dataDefault.listNgonNgu.filter(
            (item) => item.id !== data
          );
          newArrayNgonNgu.length === 0
            ? (this.disableAddLanguageTabs = true)
            : (this.disableAddLanguageTabs = false);
          this.mData.dataDefault.listNgonNgu = newArrayNgonNgu;
          this.showAddLanguageTabs = true;
          let newTabName = ++this.mData.indexLanguageTabs + "";
          this.mData.tabsName = data;
          const audioObj = {
            languageCode: data,
            audioData: "",
            audioExtension: "",
            fileName: "",
            type: "",
            signedAudioUrl: "",
            id: null
          };
          this.mData.audiosNew.push(audioObj);

          const transObj = {
            languageCode: data,
            guideName: "",
            description: "",
          };
          this.mData.translationsNew.push(transObj);

          this.mData.languageTabs.push({
            key: this.mData.indexLanguageTabs++,
            title: titleTabsLanguage,
            name: data,
            id: data,
            indexTabs: DataService.Languages.findIndex(l => l.id === data) !== -1 
              ? DataService.Languages.findIndex(l => l.id === data) + 1 
              : 99,
            audio: audioObj,
            translation: transObj,
            audios: this.mData.audiosNew,
            translations: this.mData.translationsNew,
            showFileAudio: false,
            showButtonClose: data !== "vi" ? true : false,
            fileList: [],
          });
          this.mData.languageTabs.sort((a, b) => a.indexTabs - b.indexTabs);
          this.mData.editableLanguageTabs = data;
          if (newArrayNgonNgu.length > 0) {
            this.mData.dataForm.languageCode = newArrayNgonNgu[0].id;
          } else this.mData.dataForm.languageCode = "";
        }
      }
    },
    renderNameTabs(id) {
      const lang = DataService.Languages.find((item) => item.id === id);
      return lang ? lang.name : id;
    },
    removeLanguageTab(targetName) {
      let tabs = this.mData.languageTabs;
      let activeName = this.mData.editableLanguageTabs;
      tabs.forEach((item) => {
        if (!item.idForDelete) {
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                let nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                  activeName = nextTab.name;
                }
              }
            });
          }
          this.mData.editableLanguageTabs = activeName;
          this.mData.dataDefault.listNgonNgu.push({
            id: targetName,
            name: this.renderNameTabs(targetName),
          });
          this.disableAddLanguageTabs = false;
          this.mData.languageTabs = tabs.filter(
            (tab) => tab.name !== targetName
          );
          this.mData.translationsNew = this.mData.translationsNew.filter(
            (item) => item.languageCode !== targetName
          );
          this.mData.audiosNew = this.mData.audiosNew.filter(
            (item) => item.languageCode !== targetName
          );
        } else if (item.idForDelete && item.id === targetName) {
          Swal.fire({
            title: "Cảnh báo",
            text: "Thuyết minh tự động sẽ bị xóa",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Xóa",
            cancelButtonText: "Hủy",
          }).then((result) => {
            if (result.isConfirmed) {
              if (activeName === targetName) {
                tabs.forEach((tab, index) => {
                  if (tab.name === targetName) {
                    let nextTab = tabs[index + 1] || tabs[index - 1];
                    if (nextTab) {
                      activeName = nextTab.name;
                    }
                  }
                });
              }
              try {
                Promise.all([
                  mushroomDulich.thedulich.agm_guide_translation_deleteAsync({
                    body: { translation_id: item.idForDelete }
                  }),
                ]).then(async (res) => {
                  this.mData.dataAudioUrl = {};
                  this.mData.audiosNew = [];
                  this.mData.translationsNew = [];
                  this.mData.editableLanguageTabs = activeName;
                  this.mData.languageTabs = [];
                  this.mData.dataForm.languageCode = targetName;
                  this.mData.dataDefault.listNgonNgu.push({
                    id: targetName,
                    name: this.renderNameTabs(targetName),
                  });
                  this.fn_go();
                });
              } catch (error) {
                console.error("error", error);
              }
            }
          });
        }
      });
    },
  },
  async created() {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (this.mData.viewMode === "create") {
      this.mData.dataForm.languageCode = "en";
      this.showAddLanguageTabs = true;

      this.mData.dataDefault.listNgonNgu =
        this.mData.dataDefault.listNgonNgu.filter((item) => item.id !== "vi");
      const viAudioObj = {
        languageCode: "vi",
        audioData: "",
        audioExtension: "",
        fileName: "",
        type: "",
        signedAudioUrl: "",
        id: null
      };
      this.mData.audiosNew.push(viAudioObj);

      const viTransObj = {
        languageCode: "vi",
        guideName: "",
        description: "",
      };
      this.mData.translationsNew.push(viTransObj);

      this.mData.languageTabs.push({
        key: 0,
        title: "Tiếng Việt",
        name: "vi",
        id: "vi",
        indexTabs: 1,
        audio: viAudioObj,
        translation: viTransObj,
        audios: this.mData.audiosNew,
        translations: this.mData.translationsNew,
        showFileAudio: false,
        showButtonClose: false,
        fileList: [],
      });
      this.mData.editableLanguageTabs = "vi";
    }
    await this.getDataDDAT();
    if (this.$router.currentRoute.params.code) {
      this.getDataByGuideCode(this.$router.currentRoute.params.code);
    }
    // window.addEventListener('paste', (event) => {
    //   setTimeout(() => {
    //     if (this.mData.dataForm.guideName && this.mData.dataForm.guideName.length == 50) this.mData.dataForm.guideName = undefined
    //     if (this.mData.dataForm.description && this.mData.dataForm.description.length == 2000) this.mData.dataForm.description = undefined
    //   }, 100)
    // })
  },
};
</script>

<style>
.alert-message {
  word-break: break-word;
}
</style>
<style lang="scss" scoped>
::v-deep .list-album-image {
  background: #f0f3f5;
  margin: 5px 5px 15px;
  border-radius: 10px;
  padding: 15px;
  .position-css {
    .el-image {
      max-width: 195px;
    }
    .remove-icon {
      top: -10px;
      right: -10px;
    }
  }
}
::v-deep .upload-album-image {
  .el-upload {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }
}
::v-deep .d-flex-language {
  display: flex;
  label {
    margin-right: 10px;
  }
}
@media (max-width: 992px) {
  .list-album-image {
    // max-width: 430px;
    width: calc(100% - 20px);
    .position-css {
      max-width: calc(100% - 20px) !important;
      .el-image {
        max-width: calc(100% - 50px);
      }
      .remove-icon {
        .el-image {
          max-width: 100%;
        }
      }
    }
  }
}
@media (min-width: 1751px) {
  ::v-deep .upload-album-image {
    .el-upload {
      height: 202px;
      width: 202px;
    }
  }
}
@media (min-width: 1501px) and (max-width: 1750px) {
  ::v-deep .upload-album-image {
    .el-upload {
      height: 156px;
      width: 156px;
    }
  }
}
@media (min-width: 1241px) and (max-width: 1500px) {
  ::v-deep .upload-album-image {
    .el-upload {
      height: 133px;
      width: 133px;
    }
  }
}
@media (min-width: 993px) and (max-width: 1240px) {
  ::v-deep .upload-album-image {
    .el-upload {
      height: 112px;
      width: 112px;
    }
  }
}
::v-deep .requied-label {
  .el-form-item__label::before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}
.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  margin-bottom: 0;
  margin-top: 10px;
}
.custom__label::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
::v-deep .card {
  .card-body__css {
    min-height: calc(100vh - 156px);
  }
}
::v-deep .upload {
  display: flex;
  align-items: center;
  .el-upload__tip {
    margin-left: 20px;
    margin-top: 0;
    p {
      line-height: 15px;
      font-weight: 500;
    }
  }
}
::v-deep .el-upload-list--text {
  display: none;
}
.fa-trash-alt:before {
  color: red;
  font-size: 16px;
}
.list-file__custom {
  &-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-name {
      &:hover {
        cursor: pointer;
      }
    }
    &-icon {
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
